
import { useState, useEffect } from "react";

export const useTempUserData = () => {
  const [tempUserData, setTempUserData] = useState<any>(null);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const savedTempUserData = localStorage.getItem('tempUserData');
    if (savedTempUserData) {
      const userData = JSON.parse(savedTempUserData);
      setTempUserData(userData);
      setEmail(userData.email || "");
    }
  }, []);

  return { tempUserData, email, setEmail };
};
